import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch } from "react-redux";
import { setDrawerActiveMenu } from "../../store/features/webUtilitiesSlice";
import logo from "../../assets/images/logo.png";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { GET_GENERAL_PAGES } from "../../config/ApisCollection";

export default function Menu() {
  const dispatch = useDispatch();
  const accessToken = secureLocalStorage.getItem("accessToken");
  const [generalData, setGeneralData] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(35));
  };

  const GetGeneralPages = async () => {
    setIsLoading(true);
    const get_header = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      await axios
        .post(GET_GENERAL_PAGES, { country: "us" }, get_header)
        .then((response) => {
          setGeneralData(response.data);
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading("error");
    }
  };

  useEffect(() => {
    GetGeneralPages();
  }, []);
  // console.log(generalData);
  return (
    <div className="w-full h-full">
      {generalData !== null ? (
        <>
          <div className="w-full flex mb-2">
            <SideBarBack handleCloseDrawer={handleCloseDrawer} />
          </div>
          <div className="flex flex-col text-center gap-2 mt-6 w-11/12 mx-auto pb-14">
            <img src={logo} className="w-9/12 mx-auto mb-10" />
            {isLoading === null || isLoading === true ? (
              <div className="flex flex-col justify-center h-[50vh]">
                Loading...
              </div>
            ) : generalData != null ? (
              <>
                <h1 className="font-bold text-3xl">About Us</h1>
                <div
                  dangerouslySetInnerHTML={{
                    __html: generalData[5].description,
                  }}
                ></div>
              </>
            ) : (
              <div className="flex justify-center">Something went wrong...</div>
            )}
          </div>
        </>
      ) : (
        <div className="flex flex-col justify-center h-[50vh]">
          <p className="text-center">Loading...</p>
        </div>
      )}
      {/* <div className="w-full h-52 absolute bottom-0 left-0 right-0 bg-gradient-to-t from-white to-transparent" /> */}
    </div>
  );
}
